<air-select
  [dataSource]="_selectDataSource"
  [formControl]="_formControl"
  label="Username Sorting"
></air-select>
